import { db } from "@/firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

// Runtime data-mirror reader.
//
// The Airtable sync (scripts/sync-expressions.mjs, run with MIRROR_TO_FIRESTORE=1)
// writes the published payload into Firestore docs appData/{expressions,
// masterclasses}. Reading them here on boot lets a data refresh go live WITHOUT a
// redeploy. On any miss/error we return null so the caller keeps the build-time
// JSON that already shipped — the mirror is a live override, never a hard
// dependency. See docs/airtable-runtime-mirror-design.md.
const COLLECTION = "appData";

async function fetchItems(docId) {
  try {
    const snap = await getDoc(doc(db, COLLECTION, docId));
    if (!snap.exists()) return null;
    const data = snap.data();
    return Array.isArray(data?.items) ? data.items : null;
  } catch (e) {
    return null;
  }
}

/** Live published expressions, or null → caller falls back to the baked JSON. */
export function fetchPublishedExpressions() {
  return fetchItems("expressions");
}

/** Live published masterclasses, or null → caller falls back to the baked JSON. */
export function fetchPublishedMasterclasses() {
  return fetchItems("masterclasses");
}

/**
 * Live engine content bundle (whole-doc shape: domains/situations/expressions,
 * mirrored by the same sync), or null → baked engineContent.generated.json.
 */
export async function fetchEngineContent() {
  try {
    const snap = await getDoc(doc(db, COLLECTION, "engineContent"));
    if (!snap.exists()) return null;
    const data = snap.data();
    return Array.isArray(data?.expressions) ? data : null;
  } catch (e) {
    return null;
  }
}

/**
 * Pilot pacing parameters (appData/engineConfig) — config, not constants
 * (brief §5). Null on miss/error; engineScheduler.resolveConfig() overlays
 * whatever arrives onto the baked defaults, so a missing doc never stalls.
 */
export async function fetchEngineConfig() {
  try {
    const snap = await getDoc(doc(db, COLLECTION, "engineConfig"));
    return snap.exists() ? snap.data() : null;
  } catch (e) {
    return null;
  }
}
